import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { RootState } from '../../redux/rootReducer';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { checkAuthState } from '../../redux/slices/authSlice';

const Home: React.FC = () => {
  const dispatch = useDispatch<ThunkDispatch<RootState, void, Action>>()
  const { user, isAuthenticated } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    dispatch(checkAuthState());
  }, [dispatch]);
  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          {isAuthenticated && (
            <div className="card">
              <div className="card-header">
                <h3>Welcome to the Brisby Data Platform</h3>
              </div>
              <div className="card-body">
                <p>
                  This platform is designed to securely capture, process, and display data from connected IoT devices used in veterinary hospitals and clinics. By unifying device telemetry with patient and practice workflows, the system helps teams monitor patients more effectively, streamline daily operations, and support meaningful clinical interactions.
                </p>
              </div>
            </div>
          )}
          {!isAuthenticated && (
            <div className="card">
              <div className="card-header">
                <h3>Access Restricted</h3>
              </div>
              <div className="card-body">
                <p>This platform is intended for authorized users only. To protect patient data and connected device systems, access is limited to individuals with an active account.</p>
                <p>
                  If you already have an account, please <Link to="/login">log in here</Link>.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
